import { ApiError } from "@tovi/shared";
import { api } from "./api.ts";

/**
 * A manager putting somebody else on a till from the staff app (`#230`),
 * through `POST /store/shifts/override` — the API side shipped in `#170`.
 *
 * Unlike `device.ts`'s three calls, this one goes through `api()`: the route
 * answers in the app's own envelope, not RFC 8628's, so there is no
 * hand-rolled 401 handling to repeat here — `api()` already signs the
 * terminal out on one.
 */
export type OverrideResult =
  { kind: "done" } | { kind: "gone" } | { kind: "refused" } | { kind: "notFound" };

export async function overrideCode(userCode: string, employeeId: string): Promise<OverrideResult> {
  try {
    await api("/store/shifts/override", { method: "POST", body: { userCode, employeeId } });
    return { kind: "done" };
  } catch (caught) {
    if (caught instanceof ApiError) {
      if (caught.reason === "deviceCodeNotPending") return { kind: "gone" };
      if (caught.code === "FORBIDDEN") return { kind: "refused" };
      if (caught.code === "NOT_FOUND") return { kind: "notFound" };
    }
    throw caught;
  }
}
